import { z } from 'zod';

export const MembershipTierSchema = z.enum(['BASIC', 'PREMIUM', 'ELITE']);

export const CreateMembershipPlanInputSchema = z.object({
  name: z.string().min(1).max(120),
  description: z.string().max(500).optional().nullable(),
  tier: MembershipTierSchema,
  priceInSmallestUnit: z.number().int().min(0),
  marketingWeeklyPriceInSmallestUnit: z.number().int().min(0),
  creditAmountInSmallestUnit: z.number().int().min(1),
  slotPriceInSmallestUnit: z.number().int().min(0).optional().nullable(),
  discountPercent: z.number().int().min(0).max(100).default(0),
  slotsPerMonth: z.number().int().min(1).optional().nullable(),
  guestPassesPerMonth: z.number().int().min(0).default(0),
  maxReservationMinutes: z.number().int().min(30).max(24 * 60).default(90),
  bookingAdvanceDays: z.number().int().min(1).max(365).default(31),
  currency: z.string().length(3).toUpperCase().default('CZK'),
  sortOrder: z.number().int().min(0).default(0),
  isActive: z.boolean().default(true),
});

export const UpdateMembershipPlanInputSchema = CreateMembershipPlanInputSchema.partial();

export const ListMembershipPlansQuerySchema = z
  .object({
    tenantId: z.string().uuid().optional(),
    gymId: z.string().uuid().optional(),
  })
  .refine((value) => !(value.tenantId && value.gymId), {
    message: 'Provide either tenantId or gymId',
  });

export const CreateMembershipPurchaseInputSchema = z.object({
  planId: z.string().uuid(),
  tenantId: z.string().uuid(),
  savePaymentMethod: z.boolean().optional().default(false),
});

export const ConfirmMembershipPurchaseInputSchema = z.object({
  subscriptionId: z.string().min(1),
});

export const GrantManualMembershipInputSchema = z.object({
  tenantId: z.string().uuid(),
  tier: MembershipTierSchema,
  months: z.number().int().min(1).max(60),
  creditAmountInSmallestUnit: z.number().int().min(1).max(2147483647).optional(),
  slotPriceInSmallestUnit: z.number().int().min(0).max(2147483647).optional(),
});

export type CreateMembershipPlanInput = z.infer<typeof CreateMembershipPlanInputSchema>;
export type UpdateMembershipPlanInput = z.infer<typeof UpdateMembershipPlanInputSchema>;
export type CreateMembershipPurchaseInput = z.infer<typeof CreateMembershipPurchaseInputSchema>;
export type ConfirmMembershipPurchaseInput = z.infer<typeof ConfirmMembershipPurchaseInputSchema>;
export type GrantManualMembershipInput = z.infer<typeof GrantManualMembershipInputSchema>;
